"use strict";

module.exports = {
    PasswordStrength: require("./password-strength.js"),
    commonPasswords: require("../data/common-passwords.json"),
    trigraphs: require("../data/trigraphs.json")
};
